import axios from '@/utils/axios';
import { devError } from '@/utils/dev-console';

// ----------------------------------------------------------------------
// Types
// ----------------------------------------------------------------------

export type SendOTPParams = {
  email: string;
  productId: string;
};

export type VerifyOTPParams = {
  email: string;
  otp: string;
  productId: string;
};

export type SendOTPResponse = {
  success: boolean;
  message: string;
  error?: string;
};

export type VerifyOTPResponse = {
  success: boolean;
  message?: string;
  error?: string;
  attemptsLeft?: number;
  token?: string;
};

// ----------------------------------------------------------------------
// Token Storage
// ----------------------------------------------------------------------

const GUEST_TOKEN_KEY = 'guest_access_token';

export function storeGuestToken(token: string): void {
  try {
    localStorage.setItem(GUEST_TOKEN_KEY, token);
  } catch (error) {
    devError('Failed to store guest token:', error);
  }
}

export function getGuestToken(): string | null {
  try {
    return localStorage.getItem(GUEST_TOKEN_KEY);
  } catch (error) {
    devError('Failed to get guest token:', error);
    return null;
  }
}

export function clearGuestToken(): void {
  try {
    localStorage.removeItem(GUEST_TOKEN_KEY);
  } catch (error) {
    devError('Failed to clear guest token:', error);
  }
}

// ----------------------------------------------------------------------
// API Functions
// ----------------------------------------------------------------------

export async function sendOTP(params: SendOTPParams): Promise<SendOTPResponse> {
  const res = await axios.post('/api/auth/otp?endpoint=send', params);
  return res.data;
}

export async function verifyOTP(params: VerifyOTPParams): Promise<VerifyOTPResponse> {
  const res = await axios.post('/api/auth/otp?endpoint=verify', params);
  
  if (res.data.token) {
    storeGuestToken(res.data.token);
  }
  
  return res.data;
}
